// extracted by mini-css-extract-plugin
module.exports = {"help":"Help_help__1KvpC","primary":"Help_primary__RvloX","secondary":"Help_secondary__2grz4"};